export const formatHomePageData = (response: any[]) => {
  return response.map((item, index) => ({
    key: `key-${index + 1}`,
    enabled: item.enabled,
    defaultIcon: {
      url: item.config.defaultIcon,
      previewUrl: item.config.defaultIconPreviewUrl,
    },
    activeIcon: {
      url: item.config.activeIcon,
      previewUrl: item.config.activeIconPreviewUrl,
    },
    text: item.config.text,
    connector: item.config.connector,
    position: "",
  }));
};

export const formatSaveCustomization = (data: any[]) => {
  return data.map((item) => ({
    // id: item.key,
    enabled: item.enabled,
    config: {
      defaultIcon: item.defaultIcon.url,
      activeIcon: item.activeIcon.url,
      text: item.text,
      connector: item.connector,
    },
  }));
};
